import { useDispatch, useSelector } from "react-redux";
import { _ } from "src/services";
import { Modals, ModalsAction } from "src/store";
import { ShareSocials } from "../share/share.socials";
import { Modal } from "./modal";

export const ShareModal: React.FC<{ title?: string }> = ({ title }) => {

    //#region dependencies

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);

    //#endregion

    //#region poperties

    const location = window.location.href;
    const shareTitle = _("shareTitle").replaceAll("{title}", title || "");

    //#endregion

    //region methods

    const onClose = () => {
        dispatch(ModalsAction.hideShare());

    };


    //#endregion

    //#region helpers

    const renderBody = () => {
        return (
            <>
                <div className="sub-title text-center mb-1">{_("selectSocialNetwork")}</div>
                <ul className="share-links d-flex align-items-center justify-content-center list-unstyled my-4">
                    {ShareSocials.map(({ url, icon, title }, index) => (
                        <li className="m-2 mx-3" key={index}>
                            <a href={url(location, shareTitle)} className="actions" title={title()} target="_blank" rel="noopener noreferrer">
                                <span className="center-item">
                                    {icon()}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            </>
        );
    };

    //#endregion

    return (
        <Modal title={_("share")} show={modals.share} onClose={onClose} className="modal-component--share">
            <div className="content text-center">
                {renderBody()}
            </div>
        </Modal>
    );

};